import { Avatar, AvatarFallback, AvatarImage } from '@monksflow/monks-ui';
import { useGetDownloadUrl } from '@/shared/hooks/useGetDownloadUrl';

interface PersonaAvatarProps {
  name: string;
  photoAssetId?: string;
  /** Edge length in pixels. Callers span 16 to 152, so this stays a number rather than a size token. */
  size?: number;
  circular?: boolean;
}

export const PersonaAvatar = ({ name, photoAssetId, size = 32, circular }: PersonaAvatarProps) => {
  const { downloadUrl } = useGetDownloadUrl(photoAssetId);

  return (
    <Avatar
      roundness={circular ? 'full' : 'rounded'}
      style={{ width: size, height: size }}
      data-testid="persona-avatar"
    >
      <AvatarImage src={downloadUrl} alt={name} />
      <AvatarFallback>{name.charAt(0).toUpperCase()}</AvatarFallback>
    </Avatar>
  );
};
